import Rbac from "../../../utils/Rbac";
import {isViewVisible} from "../../../utils/ViewSettings";
import FacilitiesView from "./components/FacilitiesView";
import {createSubmenuItems} from "../../../utils/Helper";
import React from "react";
import t from "../../helpers/t";

export const rbac = new Rbac({
    _rbac: {
        "admin": {
            write: true,
            editFacility: true,
            openDoor: true
        },
        "manager": {
            write: false,
            editFacility: false,
            openDoor: true
        },
        "manager-location": {
            write: false,
            editFacility: false,
        },
        "user": {
            write: false,
            editFacility: false,
        },
        "garage-staff": {
            write: false,
            editFacility: false,
        }
    }
});
export const FacilityPage = (props) => {
    let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    let indexView = isViewVisible('facilities','contingents') ? 'facilities' : '';
    return (
        <>
            {(_view === 'facilities' || (_view === 'index' && indexView === 'facilities')) &&
                <FacilitiesView
                    name={t("facilities")}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                    submenuItems={createSubmenuItems('facilities')}
                    createAccessBar={props.createAccessBar}
                />
            }
        </>
    );
};